import classnames from 'classnames'
import LoadingDots from 'shared-web/src/components/Loading'

import colors from 'styles/colors.json'

function Cancel({ onClick }) {
  return (
    <div
      style={{ cursor: 'pointer', marginRight: 15 }}
      className="dsg-Body color-navy"
      onClick={onClick}
    >
      Cancel
    </div>
  )
}

function Save({changed, onClick}) {
  return (
    <div
      className={classnames('dsg-Body', { link: changed, 'color-navy-light': !changed })}
      onClick={onClick}
    >
      Save
    </div>
  )
}

function CancelAndSave({ updating, changed, onCancel, onSave }){
  let content
  if (updating) {
    content = <LoadingDots color={colors['color-teal']} size="small"/>
  } else {
    content = [
      <Cancel onClick={onCancel} key="cancel"/>,
      <Save changed={changed} onClick={onSave} key="save"/>
    ]
  }
  return (
    <div className="flex">
      {content}
    </div>
  )
}

export default CancelAndSave



// WEBPACK FOOTER //
// ./src/scripts/components/customer/CompanyCard/CancelAndSave.js